import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function EmailOutlineSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.98 4.523c.013.103.02.207.02.314v10.326a2.337 2.337 0 01-1.996 2.312l-.013.023h-.228a2.345 2.345 0 01-.1.002H2.336c-.034 0-.067 0-.1-.002h-.183l-.01-.016A2.336 2.336 0 010 15.163V4.837c0-.106.007-.21.02-.313A1.763 1.763 0 011.77 2.5H18.23c1.095 0 1.911.973 1.748 2.023zM18.5 15.187V7.268a4.157 4.157 0 01-.397.299l-4.639 3.076 5.036 4.544zm-16.994.077a.849.849 0 01-.006-.1V7.267c.126.107.258.207.397.299l4.654 3.086-5.045 4.611zm1.22-8.947L7.933 9.77l2.07 1.224 1.977-1.167 5.294-3.51a2.654 2.654 0 001.108-1.565l.058-.228A.837.837 0 0017.663 4H2.336a.835.835 0 00-.776.524l.058.228c.16.64.555 1.198 1.108 1.565zm.2 9.68l4.914-4.49.944.627a2.203 2.203 0 002.433 0l.957-.635 4.952 4.469-.017.03H2.927z",
    clipRule: "evenodd"
  }));
}

export default EmailOutlineSmall;
//# sourceMappingURL=EmailOutlineSmall.js.map